import {CourseParticipantForm} from "./components/course-participant-form";
import {ComponentService} from "./service/component";
import container from "./container/config";
import SERVICE_IDENTIFIER from "./container/identifiers";
import {Application} from "./application/application";
import 'foundation-sites';
import {TAG} from "./container/tags";
import {VenuesComponent} from "./components/venues";
import {CountryAndRegionComponent} from "./components/country-and-region";
import {CourseShippingForm} from "./components/course-shipping-form";
import HideOnValue from "./components/hide-on-value";

require("@babel/polyfill");

(($) => $(() => {

    $(document).foundation();
    let components = container.get<ComponentService>(SERVICE_IDENTIFIER.COMPONENTS);
    components.addComponent('.js-event-listing', TAG.EVENTS_LIST);
    components.addComponent('.js-event-detail', TAG.EVENTS_DETAIL);
    components.addComponent('.js-locked', TAG.BUTTON_LOCKED);
    components.addComponent('.js-venues', VenuesComponent);
    components.addComponent('.js-countries-and-regions', CountryAndRegionComponent);
    components.addComponent('.js-events-moderation', TAG.EVENT_MODERATOR);
    components.addComponent('.js-courses-moderation', TAG.COURSE_MODERATOR);
    components.addComponent('.js-course-form', TAG.COURSE_FORM);
    components.addComponent('.js-course-participants', CourseParticipantForm);
    components.addComponent('.js-delivery-charges', CourseShippingForm);
    components.addComponent('.js-course-publish', TAG.COURSE_PUBLISH);
    components.addComponent('.js-hide-on-value', HideOnValue);
    container.get<Application>(SERVICE_IDENTIFIER.APPLICATION).init();

}))(jQuery);